import React from 'react';
import { Typography, Grid } from "antd";
import { t } from "i18next";
import { useUser } from "../../../core/context/UserContext";

const { Text } = Typography;

/**
 * Randevu mali özeti — yatay şerit: Toplam Fiyat | Ödenen | Kalan Borç.
 * Renk yalnızca anlam taşıyan yerde: kalan borç (kırmızı) / tamamı ödendi (yeşil).
 */
// tinted: kutu zemini durum rengiyle tonlanır (borç → kırmızımsı, ödendi → yeşilimsi)
// style: dış kutu stiline ek/üzerine yazma (ör. başka bir kartın içine gömülürken çerçeveyi kaldırmak)
export default function PriceSummaryPreview({ totalPrice, totalPaid, currency = 'TRY', tinted = false, style }) {
    const { formatPrice } = useUser();
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.sm;

    // -1: fiyat hesaplanamadı (orijinal koddaki mantık)
    const isValid = totalPrice !== -1 && totalPaid !== -1;
    const balance = isValid ? (totalPrice - totalPaid) : 0;
    const hasDebt = balance > 0;

    const money = (val) => isValid ? formatPrice(val, { currency }) : '-';

    const Stat = ({ label, value, color, strong, align = 'left' }) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0, textAlign: align }}>
            <Text type="secondary" style={{ fontSize: 12 }}>{label}</Text>
            <Text strong style={{ fontSize: strong ? 20 : 16, lineHeight: 1.2, color, whiteSpace: 'nowrap' }}>
                {value}
            </Text>
        </div>
    );

    return (
        <div style={{
            border: `1px solid ${tinted && isValid ? (hasDebt ? '#ffccc7' : '#b7eb8f') : '#f0f0f0'}`,
            borderRadius: 8,
            padding: '12px 16px',
            background: tinted && isValid ? (hasDebt ? '#fff1f0' : '#f6ffed') : '#fff',
            ...style,
        }}>
            <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr',
                gap: 12,
                alignItems: 'end',
            }}>
                <Stat label={t('Total Price')} value={money(totalPrice)} />
                <Stat label={t('Paid Amount')} value={money(totalPaid)} />
                <div style={{ gridColumn: isMobile ? '1 / -1' : undefined }}>
                    <Stat
                        label={hasDebt || !isValid ? t('Remaining Debt') : t('Fully Paid')}
                        value={money(balance)}
                        color={!isValid ? undefined : hasDebt ? '#cf1322' : '#389e0d'}
                        strong
                        align={isMobile ? 'left' : 'right'}
                    />
                </div>
            </div>
        </div>
    )
}
